import * as types from './mutation-types'

export default {
    [types.BOOTSTRAP_ACCOUNTS] (state, accounts) {
      state.accounts = accounts
    },

    [types.SET_TOTAL_ACCOUNTS] (state, totalAccounts) {
        state.totalAccounts = totalAccounts
    },
    [types.SET_TOTAL_FUNDER_ACCOUNTS](state, totalFunderAccounts) {
        state.totalFunderAccounts = totalFunderAccounts
    },

    [types.FUNDER_ACCOUNTS](state, funderAccounts) {
        state.funderAccounts = funderAccounts
    },

    [types.ADD_ACCOUNT] (state, data) {
        state.accounts.push(data.account)
    },

    [types.UPDATE_ACCOUNT] (state, data) {
        let pos = state.accounts.findIndex(account => account.id === data.account.id)

        state.accounts[pos] = data.account
    },

    // [types.DELETE_ACCOUNT] (state, id) {
    //     let index = state.customers.findIndex(customer => customer.id === id)
    //     state.customers.splice(index, 1)
    // },

    // [types.DELETE_MULTIPLE_CUSTOMERS] (state, selectedCustomers) {
    //     selectedCustomers.forEach((customer) => {
    //         let index = state.customers.findIndex(_cust => _cust.id === customer.id)
    //         state.customers.splice(index, 1)
    //     })
    //
    //     state.selectedCustomers = []
    // },

    [types.SET_SELECTED_ACCOUNTS] (state, data) {
        state.selectedAccounts = data
    },
    [types.SET_SELECTED_FUNDER_ACCOUNT](state, data) {
        state.selectedFunderAccount = data
    },
    [types.SET_SELECTED_AUDIT_ACCOUNT](state, data) {
        state.selectedAuditAccount = data
    },
    [types.SET_SELECTED_ISLAMIC_FORM](state, data) {
      state.selectedIslamicForm = data
    },
    [types.SET_SELECT_ALL_STATE] (state, data) {
        state.selectAllField = data
    },
    [types.SET_SELECT_ALL_FUNDER_STATE](state, data) {
        state.selectAllFunderField = data
    },
    [types.VIEW_ACCOUNT](state, data) {
        state.viewAccount = data
    },
}
